/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_LightInputs */

const en_theme_light = /** @type {(inputs: Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme: light`)
};

const th_theme_light = /** @type {(inputs: Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ธีม: สว่าง`)
};

const ja_theme_light = /** @type {(inputs: Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーマ: ライト`)
};

const fr_theme_light = /** @type {(inputs: Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thème : clair`)
};

const es_theme_light = /** @type {(inputs: Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema: claro`)
};

const ru_theme_light = /** @type {(inputs: Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тема: светлая`)
};

const zh_theme_light = /** @type {(inputs: Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主题：浅色`)
};

const vi_theme_light = /** @type {(inputs: Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao diện: sáng`)
};

/**
* | output |
* | --- |
* | "Theme: light" |
*
* @param {Theme_LightInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const theme_light = /** @type {((inputs?: Theme_LightInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_LightInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_theme_light(inputs)
	if (locale === "ja") return ja_theme_light(inputs)
	if (locale === "fr") return fr_theme_light(inputs)
	if (locale === "es") return es_theme_light(inputs)
	if (locale === "ru") return ru_theme_light(inputs)
	if (locale === "zh") return zh_theme_light(inputs)
	if (locale === "vi") return vi_theme_light(inputs)
	return en_theme_light(inputs)
});